
import Vue from "vue";
import { DocumentPageSettings } from "@/utils/documents/page-settings";

export default Vue.extend({
	props: {
		value: Object as () => DocumentPageSettings
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	},
});
